// fill.pipe.ts

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'fill' })
export class FillPipe implements PipeTransform {
    transform(string) {
        let value = parseInt(string);
        return (new Array(value)).fill(1);
    }
}